import { SelectedFilterTags } from './filter_main/ui/selected_filter_tags';

export default class FilterTagsList extends React.Component {
  constructor(props) {
    super(props);
    this.filter = this.filter.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.renderTags = this.renderTags.bind(this);
    this.handleRemoveShoreDistance = this.handleRemoveShoreDistance.bind(this);
    this.handleRemoveDistance = this.handleRemoveDistance.bind(this);
    this.priceString = this.priceString.bind(this);
    this.areaCenterDefaultDistance = [0, this.props.data.default_distance || this.props.data.max_distance];
  }

  filter(key, value) {
    const filters = { ...this.props.filters, [key]: value };
    this.props.filter(filters);
  }

  handleRemove(id, enabled_ids, condition_param) {
    const newEnabledIds = enabled_ids.filter((item) => item !== id);
    this.filter(condition_param, newEnabledIds);
  }

  handleRemoveShoreDistance() {
    this.filter('shoreDistance', 0);
  }

  handleRemovePrices() {
    this.filter('prices', [0, this.props.price_max_end]);
  }

  handleRemoveDistance() {
    this.filter('distance', this.areaCenterDefaultDistance);
  }

  handleRemoveRecovery() {
    this.filter('recovery', this.recovery);
  }

  renderTags(filterParamsProperty, conditionParam) {
    const selectedTagsIds = this.props.filters[conditionParam];
    return (
      <SelectedFilterTags
        selectedTagsIds={selectedTagsIds}
        filterParamsProperty={filterParamsProperty}
        onRemoveTag={(tagId, selectedIds) => this.handleRemove(tagId, selectedIds, conditionParam)}
      />
    );
  }

  priceString() {
    const start = Math.floor(this.props.filters.prices[0]);
    const end = Math.floor(this.props.filters.prices[1]);
    const start_string = start > 0 ? `от ${start}` : '';
    const end_string = end < this.props.price_max_end ? `до ${end}` : '';
    return `${start_string} ${end_string}`;
  }

  render() {
    let shoreDistance = this.props.filters.shoreDistance;
    const areaCenterNotDefault =
      this.props.filters.distance && JSON.stringify(this.props.filters.distance) !== JSON.stringify(this.areaCenterDefaultDistance);

    const hasActiveFilters = () => {
      const filters = this.props.filters;

      return (
        (Array.isArray(filters.prices) && (filters.prices[0] > 0 || filters.prices[1] < this.props.price_max_end)) ||
        (filters.shoreDistance && filters.shoreDistance > 0) ||
        (filters.distance && JSON.stringify(filters.distance) !== JSON.stringify(this.areaCenterDefaultDistance)) ||
        Object.entries(filters)
          .filter(([key]) => !['less_capacity', 'all_categories', 'prices', 'not_required_prepayment', 'distance'].includes(key))
          .some(([, filter]) => Array.isArray(filter) && filter.length > 0)
      );
    };

    return (
      <div className={`filter-tags-list ${this.props.campsLoaded ? '' : 'filter-tags-list-loading'}`}>
        {this.props.is_desktop && hasActiveFilters() && (
          <div className='filter-search-none__btn'>
            <button className='filter-search-none__btn__text' onClick={this.props.resetFilter}>
              Сбросить всё
            </button>
          </div>
        )}

        {this.props.filters.prices instanceof Array &&
        (this.props.filters.prices[0] > 0 || this.props.filters.prices[1] < this.props.price_max_end) ? (
          <div className='filter-tags-list__tag' onClick={() => this.handleRemovePrices()} key='prices'>
            Цена {this.priceString()} ₽
          </div>
        ) : (
          ''
        )}

        {shoreDistance === false || shoreDistance.length === 0 || shoreDistance === 0 ? (
          ''
        ) : (
          <div className='filter-tags-list__tag' onClick={this.handleRemoveShoreDistance} key='-2'>
            До {this.props.data.shore_distances[this.props.filters.shoreDistance - 1]} м до берега
          </div>
        )}

        {areaCenterNotDefault && (
          <div
            className="filter-tags-list__tag"
            onClick={this.handleRemoveDistance}
            key="-1"
          >
            {Array.isArray(this.props.filters.distance) &&
            this.props.filters.distance.length === 2
              ? `От ${this.props.data.city_name_genitive ?? this.props.data.area_center} от ${this.props.filters.distance[0]} до ${this.props.filters.distance[1]} км`
              : `От ${this.props.data.city_name_genitive ?? this.props.data.area_center} до ${this.props.filters.distance} км`}
          </div>
        )}

        {this.renderTags('recovery', 'recovery')}

        {this.renderTags('shore_distances', 'shoreDistance')}

        {this.renderTags('waters', 'waters')}

        {this.renderTags('category_list', 'categories')}

        {this.renderTags('all_category_list', 'all_enabled_categories')}

        {this.renderTags('food_types', 'foodTypes')}

        {this.renderTags('shore_distances', 'shoreDistance')}

        {this.renderTags('camp_locations', 'campLocations')}

        {this.renderTags('camp_promotions', 'campPromotions')}

        {this.renderTags(
          this.props.user_show_filter ? 'camp_service_tags_for_manager' : 'camp_service_tags',
          'campServiceTags'
        )}

        {this.renderTags(
          this.props.user_show_filter ? 'suitable_tags_for_recovery_for_manager' : 'suitable_tags_for_recovery',
          'suitableTagsForRecovery'
        )}

        {this.renderTags('apartment_service_tags', 'apartmentServiceTags')}

        {this.renderTags('treatment_profiles_tags', 'campTreatmentFactors')}

        {this.renderTags('childcare_tags', 'childcareTags')}

        {this.renderTags('deceases_list_for_filter', 'campTreatmentProfiles')}

        {this.renderTags('stars', 'stars')}

        {this.renderTags('tag_properties_list', 'tags_properties')}

        {this.renderTags('pools_tag_properties_list', 'swimming_pools_properties')}

        {this.renderTags('camp_bathhouses', 'bathTags')}
        {this.renderTags('discount', 'discount')}
        {this.renderTags('notRequiredPrepayment', 'notRequiredPrepayment')}
        {this.renderTags('singleRoom', 'singleRoom')}
        {this.renderTags('instant', 'instant')}
      </div>
    );
  }
}
